import moment from 'moment';

// Renders the chip on each row of the Past Broadcasts log — a short human-readable summary
// of which filters were applied to that broadcast's cohort.
export const filtersToCohortLabel = filters => {
  if (!filters) return '—';
  const parts = [];
  if (filters.tiers?.length > 0) parts.push(filters.tiers.join(', '));
  if (filters.noirInteraction && filters.noirInteraction !== 'any') {
    parts.push(filters.noirInteraction === 'no_request' ? 'No request' : 'Submitted request');
  }
  if (filters.purchaseFilter && filters.purchaseFilter !== 'any') parts.push(`Purchase: ${filters.purchaseFilter}`);
  if (filters.scoreMin > 0 || filters.scoreMax < 100) parts.push(`Score ${filters.scoreMin}–${filters.scoreMax}`);
  return parts.join(' · ') || 'All shoppers';
};

// Wraps the raw API broadcast row into the shape the log table consumes. The per-recipient roster
// is lazy-loaded into the row on first expand (see PastBroadcastsLog.toggleExpand).
export const adaptBroadcast = b => ({
  id: b.id,
  status: b.status,
  failureReason: b.failureReason || null,
  scheduledForRaw: b.scheduledFor,
  filters: b.filtersSnapshot || {},
  rawMessage: b.message || '',
  sentAt: b.sentAt
    ? moment(b.sentAt).format('MMM D, YYYY · h:mma')
    : b.scheduledFor
    ? moment(b.scheduledFor).format('MMM D, YYYY · h:mma')
    : moment(b.createdAt).format('MMM D, YYYY · h:mma'),
  // Raw epoch of the same date used for display — for sorting the log by date.
  whenMs: moment(b.sentAt || b.scheduledFor || b.createdAt).valueOf() || 0,
  title: b.title || '',
  message: b.message || '',
  cohort: filtersToCohortLabel(b.filtersSnapshot),
  recipients: b.recipientCount || 0,
  // Successfully sent (stored messages) vs failed-at-send (the gap) — drives the partial-send status.
  sent: b.sentCount || 0,
  failed: Math.max((b.recipientCount || 0) - (b.sentCount || 0), 0),
  delivered: b.deliveredCount || 0,
  optOuts: b.optOutCount || 0,
  sender: b.senderName || '—'
});

export const tierClass = tier => tier.toLowerCase();

export const formatPhoneInput = val => {
  const d = val.replace(/\D/g, '').slice(0, 10);
  if (d.length <= 3) return d;
  if (d.length <= 6) return `(${d.slice(0, 3)}) ${d.slice(3)}`;
  return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
};

// Serializes the userIds textarea into a clean string array.
export const parseUserIds = uids => uids.split(/[\s,]+/).map(s => s.trim()).filter(Boolean);
